import { render, staticRenderFns } from "./LearningPathDetail.vue?vue&type=template&id=4d98aad6&scoped=true&"
import script from "./LearningPathDetail.vue?vue&type=script&lang=ts&"
export * from "./LearningPathDetail.vue?vue&type=script&lang=ts&"
import style0 from "./LearningPathDetail.vue?vue&type=style&index=0&id=4d98aad6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d98aad6",
  null
  
)

export default component.exports